import classNames from 'classnames';
import type { CheckboxSize, CheckboxState } from './Checkbox.types';

const baseInteractivityClassName =
  'border border-solid focus-visible:outline-none focus-visible:ring hover:bg-state-hover';

const stateClassName: { [Key in CheckboxState]: string } = {
  checked: `${baseInteractivityClassName} border-shade-10 text-element-on-secondary bg-element-secondary`,
  unchecked: `${baseInteractivityClassName} border-default bg-default`,
  indeterminate: `${baseInteractivityClassName} border-shade-10 text-element-on-secondary bg-element-secondary`,
};

const disabledClassName =
  'border-status-disabled-dark text-status-disabled-dark bg-status-disabled';

const errorClassName: { [Key in CheckboxState]: string } = {
  checked: `${baseInteractivityClassName} border-shade-10 text-status-on-error bg-status-error`,
  unchecked: `${baseInteractivityClassName} border-status-error bg-default`,
  indeterminate: `${baseInteractivityClassName} border-shade-10 text-status-on-error bg-status-error`,
};

const sizeClassName: { [Key in CheckboxSize]: string } = {
  small: 'text-xs w-4 h-4',
  default: 'text-sm w-5 h-5',
  large: 'text-md w-6 h-6',
};

export const getCheckboxClassNames = (
  state: CheckboxState,
  size: CheckboxSize,
  disabled?: boolean,
  hasError?: boolean,
  className?: string,
): string =>
  classNames(
    className,
    'flex justify-center items-center rounded-sm border border-solid',
    disabled
      ? disabledClassName
      : hasError
        ? errorClassName[state]
        : stateClassName[state],
    sizeClassName[size],
  );
